import axios from "axios";

export default {
  getAddressList(value, limit) {
    return axios.get(`/Address/Search`, {
      params: { query: value, limit: limit },
    });
  },
  getAddressByGuid(guid) {
    return axios.get(`/Address/${guid}`);
  },
};
